import React, { useCallback, useContext } from 'react';

import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { openUploadModal } from 'components/Layouts/Form/FormBuilder/Content/AddNewContent/uploadModal';
import Icon from 'components/shared/Icon';
import Pencil from 'components/shared/Icon/icons/Pencil';
import { pageDataSelector } from 'store/page/selectors';

import LandingPageContext from '../../../contexts/LandingPageContext';
import s from '../index.module.css';
import { IListBlockItemImageProps } from './types';

function ListBlockItemImage({ file, img, onChange }: IListBlockItemImageProps) {
  const dispatch = useDispatch();
  const { readOnly } = useContext(LandingPageContext);
  const page = useSelector(pageDataSelector);

  const onClick = useCallback(async () => {
    // @ts-ignore
    const assets = await openUploadModal(dispatch, {
      type: 'media',
      multiple: false,
      selected: file ? [file] : undefined,
      defaults: {
        name: page.name,
        tags: page.tags,
      },
    });

    if (assets === null || assets?.length !== 1) {
      return;
    }

    onChange(assets[0]);
  }, [dispatch, file, onChange]);

  return (
    <div className={cx(s.imageWrapper, 'custom-listblock-image-wrapper')}>
      <img src={file ? file.url : img} alt="fact image" crossOrigin="" />
      {!readOnly && (
        <div className={s.imageCover} onClick={onClick}>
          <Icon className={s.pencil} component={Pencil} width="12px" height="12px" />
        </div>
      )}
    </div>
  );
}

export default ListBlockItemImage;
